export default import.meta.ROLLDOWN_FILE_URL_FTtSJtjR9ZCul8MOVNG7Vw